module.exports = __webpack_public_path__ + "img/ic-expand.39430301.svg";